import { Search } from 'lucide-react';

export function StudentStatusPageShell({
  title,
  description,
  kicker = 'Students',
  stats = [],
  insightCards = [],
  tableTitle,
  tableMeta,
  searchId,
  searchValue,
  onSearchChange,
  searchPlaceholder,
  filters = null,
  headerAction = null,
  columns = [],
  rows = [],
  empty = null,
  tableDescription = '',
  className = '',
}) {
  return (
    <div className={`clientsComp applicationsPage ${className}`.trim()}>
      <div className="appsHeader">
        <div className="appsHeaderCopy">
          {kicker ? <p className="appsKicker">{kicker}</p> : null}
          <h4>{title}</h4>
          <p className="appsSubtext">{description}</p>
        </div>
        <div className="appsHeaderStats">
          {stats.map((item) => (
            <div key={item.label} className="appsStatChip">
              <span>{item.label}</span>
              <strong>{item.value}</strong>
            </div>
          ))}
          {headerAction ? <div>{headerAction}</div> : null}
        </div>
      </div>

      {insightCards.length ? (
        <section className="student-insights" aria-label="Learner overview">
          {insightCards.map((item) => (
            <article key={item.label} className={`student-insight student-insight--${item.tone || 'primary'}`}>
              <div><small>{item.label}</small><strong>{item.value}</strong><p>{item.note}</p></div>
            </article>
          ))}
        </section>
      ) : null}

      <div className="appsFiltersCard">
        <label className="appsSearch input-group" htmlFor={searchId}>
          <span className="input-group-text" aria-hidden="true"><Search size={16} /></span>
          <input
            id={searchId}
            type="search"
            placeholder={searchPlaceholder}
            value={searchValue}
            onChange={onSearchChange}
          />
        </label>
        {filters ? <div className="appsFilterGroup">{filters}</div> : null}
      </div>

      <div className="appsTableCard">
        <div className="appsTableHeader">
          <div>
            <h6>{tableTitle}</h6>
            {tableDescription ? <p>{tableDescription}</p> : null}
          </div>
          {tableMeta ? <span>{tableMeta}</span> : null}
        </div>
        <div className="appsTableWrap">
          <table className="appsTable">
            <thead>
              <tr>
                {columns.map((column) => <th key={column.key}>{column.label}</th>)}
              </tr>
            </thead>
            <tbody>
              {rows.length ? rows.map((row) => (
                <tr key={row.id}>
                  {columns.map((column) => (
                    <td key={column.key}>{column.render ? column.render(row) : row[column.key]}</td>
                  ))}
                </tr>
              )) : (
                <tr>
                  <td colSpan={columns.length} className="appsEmptyState">
                    {empty}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
